import React from "react";

// interface
import { MessagesTypes } from "../../../data/messages";

// hooks
import { useProfile } from "../../../hooks";

interface RepliedMessageProps {
  isFromMe: boolean;
  message: MessagesTypes;
  fullName: string;
  onClickReplyMsg: (fromId: any, msgId: any) => void;
}
function RepliedMessage({ isFromMe, message, fullName, onClickReplyMsg }: RepliedMessageProps) {
  const { userProfile } = useProfile();
  // console.log(message);
  // const isReplyFromMe = message.meta.sender + "" === userProfile.uid + "";
  // console.log('RepliedMessage:', message);
  const isReplyFromMe = message.replyOf?.senderId === userProfile.userId;

  const getLines = () => {
    let rawText = (message.replyOf?.text || "");
    if (message.replyOf?.isAutoText2Html) rawText = String(message.replyOf?.htmlContent);
    // const tagNames = (message as any).tagNames;
    // if (tagNames) {
    //   const tagArray = tagNames.split(Const.DELIM_ROW);
    //   for (let i = 0; i < tagArray.length; ++i) {
    //     const eachTag = tagArray[i].split(Const.DELIM_VALUE);
    //     const tagId = eachTag[0];
    //     const tagName = eachTag[1];
    //     const tagMe = tagId == userProfile.userId;
    //     const css = Utils.GetCssSuffixTheme('tag-name-' + (tagMe ? "me" : "other"));
    //     rawText = rawText.replaceAll(tagName, `<span class="${css}">${tagName}</span>`)
    //     // console.log({tagId, tagName});
    //   }
    // }
    let lines = (rawText).split('\n'); // Fallback to an empty string  

    return lines;
  }

  const lines = getLines();// (message.text || "").split('\n'); // Fallback to an empty string  

  return (
    <div className="">
      <div className="replymessage-block mb-2 d-flex align-items-start hand " onClick={() => onClickReplyMsg(message?.mId, message?.replyOf?.mId)}>
        <div className="flex-grow-1 wrap-text">
          <h5 className="conversation-name">
            {isReplyFromMe ? "You" : message.replyOf?.senderName}
          </h5>

          {message.replyOf?.text && (
            // <p className="mb-0">{message.replyOf?.text}</p>
            <p className="mb-0 ctext-content text-start " >
              {lines.map((line, index) => (
                <span key={index} >
                  <span dangerouslySetInnerHTML={{ __html: line }} /> {/* Render raw HTML */}
                  {index < lines.length - 1 && <br />} {/* Add a line break except for the last line */}
                </span>
              ))}
            </p>
          )}

          {(message.replyOf?.attachments) && (
            <p className="mb-0">
              {message.replyOf?.attachments && !message.replyOf?.image && `${message.replyOf?.attachments.length} Files`}
              {message.replyOf?.image && !message.replyOf?.attachments && `${message.replyOf?.image.length} Images`}
              {message.replyOf?.image && message.replyOf?.attachments && `${message.replyOf?.attachments.length} Files & ${message.replyOf?.image.length} Images`}
            </p>
          )}

          {/* {(message.replyOf?.newimage) && (
            <div className="ctext-wrap">
              <div className="message-img mb-0">
                <div className="message-img-list">
                  <div>
                    <a className="popup-img d-inline-block" href="/dashboard">
                      <img src={message.replyOf?.newimage[0].downloadLink} alt="" className="rounded border" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )} */}

          {(message.replyOf?.image) && (
            <div className="ctext-wrap">
              <div className="message-img mb-0">
                <div className="message-img-list">
                  <div>
                    <a className="popup-img d-inline-block" href="#">
                      <img src={message.replyOf?.image[0]?.downloadThumb} alt="" className="rounded border" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default RepliedMessage;
